<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="p-(--padding-card) pt-(--space-2)">
  @if (ready()) {
    @if (entity(); as e) {
      <div class="mb-(--space-4) flex justify-between items-center">
        <div class="flex flex-col items-start">
          <h2 class="text-h1">{{ e.name }}</h2>
          <span class="text-sm text-(color:--text-secondary)">{{ dataTypeLabel() }}</span>
          <p-tag class="mt-(--space-2)" [value]="'entities.auscultationInformation.singular' | transloco" severity="info" />
        </div>

        <div class="flex gap-(--gap-normal)">
          <ces-menu-button-secondary
            [hasPermission]="{ method: 'deleteInfoDetail', assetId: assetId() ?? undefined }"
            icon="more_vert"
            [items]="deleteMenuItems()"
            menuStyleClass="ces-menu-align-right" />
        </div>
      </div>

      <div class="flex gap-(--gap-loose) flex-col">
        <ces-button-secondary
          [hasPermission]="{ method: 'putInfoDetail', assetId: assetId() ?? undefined }"
          [label]="'common.buttons.edit' | transloco"
          size="small"
          icon="edit"
          (onClick)="editEntity()" />

        <ces-property [label]="'common.labels.name' | transloco">{{ e.name }}</ces-property>

        <ces-property [label]="'common.labels.dataType' | transloco">{{ dataTypeLabel() }}</ces-property>

        @if (e.choiceListId) {
          <ces-property [label]="'entities.choiceList.singular' | transloco">{{ choiceListName() }}</ces-property>
        }

        <ces-property [label]="'common.labels.locations' | transloco" [chips]="locationNames()" />

        <ces-property [label]="'entities.measure.fields.barcode' | transloco">{{ e.barcode }}</ces-property>

        <ces-property [label]="'common.labels.description' | transloco">{{ e.description || 'N/A' }}</ces-property>
      </div>
    } @else {
      {{ 'entities.measure.messages.notFound' | transloco }}
    }
  }
</div>
